// extracted by mini-css-extract-plugin
module.exports = {"container":"BlogList-module--container--2Dcev","blogRow":"BlogList-module--blogRow--eTtYR"};